import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Accordion from 'react-bootstrap/Accordion';
import { Button, Modal } from 'react-bootstrap';
import ProjectIndexListGroup from '../ProjectIndexListGroup';
import ProjectIndexRow from '../ProjectIndexRow';
import { putRequest } from '../../requestUtils';

class ProjectIndexContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      employerDraft: props.projects.employer_draft || [],
      employerRequestedMatching: props.projects.employer_requested_matching || [],
      cloraMatching: props.projects.clora_matching || [],
      matched: props.projects.clora_matched || [],
      executedAgreement: props.projects.executed_agreement || [],
      workStarted: props.projects.work_started || [],
      workCompleted: props.projects.work_completed || [],
      onHold: props.projects.on_hold || [],
      closed: props.projects.closed || [],
      errors: [],
      showModal: false,
    };

    this.beginMatching = this.beginMatching.bind(this);
    this.requestMatching = this.requestMatching.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.setCurrentActiveKey = this.setCurrentActiveKey.bind(this);
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const status = params.get('status');
    this.setState({ defaultStatus: status || 'clora_matching' });
  }

  beginMatching(event) {
    const { csrfToken } = this.props;
    const { employerRequestedMatching, cloraMatching } = this.state;
    const index = event.target.value;
    const project = employerRequestedMatching[index];

    const newEmployerRequestedMatching = [...employerRequestedMatching];
    newEmployerRequestedMatching.splice(index, 1);

    return putRequest(
      `/projects/${project.resource_id}/begin_clora_matching`,
      {},
      csrfToken,
    ).then((response) => {
      this.setState({
        employerRequestedMatching: newEmployerRequestedMatching,
        cloraMatching: [...cloraMatching, response.data],
      });
    }).catch((err) => {
      this.setState({ errors: err, showModal: true });
    });
  }

  requestMatching(event) {
    const { csrfToken } = this.props;
    const { employerRequestedMatching, employerDraft } = this.state;
    const index = event.target.value;
    const project = employerDraft[index];

    const newEmployerDraft = [...employerDraft];
    newEmployerDraft.splice(index, 1);

    return putRequest(
      `/projects/${project.resource_id}/publish`,
      {},
      csrfToken,
    ).then((response) => {
      this.setState({
        employerDraft: newEmployerDraft,
        employerRequestedMatching: [...employerRequestedMatching, response.data],
      });
    }).catch((err) => {
      this.setState({ errors: err, showModal: true });
    });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  renderGroup(projects, callback) {
    const { showEmploymentType } = this.props;

    return (
      projects.map((project, index) => (
        <li className="list-group-item" key={project.resource_id}>
          <ProjectIndexRow
            name={project.name}
            projectLink={project.project_link}
            owner={project.owner}
            ownerLink={project.owner_link}
            company={project.company}
            companyLink={project.company_link}
            timestamp={project.timestamp}
            daysOpen={project.days_opened}
            status={project.status}
            numProposals={project.num_proposals}
            firstProposalSubmittedAt={project.first_proposal_timestamp}
            numInterests={project.pending_interest_count}
            mostRecentInterestTimestamp={project.most_recent_interest_timestamp}
            editable={project.editable}
            editLink={project.edit_link}
            specialFieldsLink={project.special_fields_link}
            isPublic={project.is_public}
            type={project.project_type}
            index={index}
            assignedRep={project.assigned_rep}
            callback={callback}
            employmentType={project.employment_type}
            showEmploymentType={showEmploymentType}
          />
        </li>
      ))
    );
  }

  setCurrentActiveKey(eventKey) {
    this.setState((prevState) => ({
      defaultStatus: prevState.defaultStatus === eventKey ? '' : eventKey,
    }));
  }

  render() {
    const {
      employerDraft,
      employerRequestedMatching,
      cloraMatching,
      matched,
      executedAgreement,
      workStarted,
      workCompleted,
      onHold,
      closed,
      errors,
      defaultStatus,
    } = this.state;

    return (
      <Accordion defaultActiveKey={defaultStatus} activeKey={defaultStatus}>
        <ProjectIndexListGroup
          count={cloraMatching.length}
          classes="bg-info"
          status="clora_matching"
          title="Clora Matching"
          setCurrentActiveKey={this.setCurrentActiveKey}
        >
          { this.renderGroup(cloraMatching) }
        </ProjectIndexListGroup>

        <ProjectIndexListGroup
          count={employerRequestedMatching.length}
          classes="bg-primary"
          status="employer_requested_matching"
          title="Employer Requested Matching"
          setCurrentActiveKey={this.setCurrentActiveKey}
        >
          { this.renderGroup(employerRequestedMatching, this.beginMatching) }
        </ProjectIndexListGroup>

        <ProjectIndexListGroup
          count={employerDraft.length}
          classes="bg-default"
          status="employer_draft"
          title="Employer Draft"
          callback={this.requestMatching}
          setCurrentActiveKey={this.setCurrentActiveKey}
        >
          { this.renderGroup(employerDraft, this.requestMatching) }
        </ProjectIndexListGroup>

        <ProjectIndexListGroup
          count={matched.length}
          classes="bg-success"
          status="clora_matched"
          title="Matched"
          setCurrentActiveKey={this.setCurrentActiveKey}
        >
          { this.renderGroup(matched) }
        </ProjectIndexListGroup>

        <ProjectIndexListGroup
          count={executedAgreement.length}
          classes="bg-success"
          status="executed_agreement"
          title="Executed Agreement"
          setCurrentActiveKey={this.setCurrentActiveKey}
        >
          { this.renderGroup(executedAgreement) }
        </ProjectIndexListGroup>

        <ProjectIndexListGroup
          count={workStarted.length}
          classes="bg-success"
          status="work_started"
          title="Work Started"
          setCurrentActiveKey={this.setCurrentActiveKey}
        >
          { this.renderGroup(workStarted) }
        </ProjectIndexListGroup>

        <ProjectIndexListGroup
          count={workCompleted.length}
          classes="bg-success"
          status="work_completed"
          title="Work Completed"
          setCurrentActiveKey={this.setCurrentActiveKey}
        >
          { this.renderGroup(workCompleted) }
        </ProjectIndexListGroup>

        <ProjectIndexListGroup
          count={onHold.length}
          classes="bg-warning"
          status="on_hold"
          title="On Hold"
          setCurrentActiveKey={this.setCurrentActiveKey}
        >
          { this.renderGroup(onHold) }
        </ProjectIndexListGroup>

        <ProjectIndexListGroup
          count={closed.length}
          classes="bg-danger"
          status="closed"
          title="Closed"
          setCurrentActiveKey={this.setCurrentActiveKey}
        >
          { this.renderGroup(closed) }
        </ProjectIndexListGroup>

        <Modal show={this.state.showModal} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Errors</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            { errors.map((error) => <h4>{error}</h4>)}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeModal}>Ok</Button>
          </Modal.Footer>
        </Modal>
      </Accordion>
    );
  }
}

ProjectIndexContainer.propTypes = {
  projects: PropTypes.shape({
    employer_draft: PropTypes.arrayOf(PropTypes.shape({})),
    employer_requested_matching: PropTypes.arrayOf(PropTypes.shape({})),
    clora_matching: PropTypes.arrayOf(PropTypes.shape({})),
    clora_matched: PropTypes.arrayOf(PropTypes.shape({})),
    executed_agreement: PropTypes.arrayOf(PropTypes.shape({})),
    work_started: PropTypes.arrayOf(PropTypes.shape({})),
    work_completed: PropTypes.arrayOf(PropTypes.shape({})),
    on_hold: PropTypes.arrayOf(PropTypes.shape({})),
    closed: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  csrfToken: PropTypes.string.isRequired,
};

export default ProjectIndexContainer;
